import { useQuery } from '@apollo/client';
import { GET_PLAYER_ASSESSMENT_REPORT_DATA } from '../queries/report-card-data.queries';
import { useLogQueryError } from '../hooks/use-log-query-error';

export const useGetReportCardData = (variables: {
  playerAssessmentId?: string;
  token?: string;
}) => {
  const { data, ...rest } = useQuery(GET_PLAYER_ASSESSMENT_REPORT_DATA, {
    variables,
    fetchPolicy: 'cache-and-network',
    skip: !variables.playerAssessmentId
  });

  useLogQueryError(rest.error, 'reportCardData');

  return {
    ...rest,
    data: data?.reportCardData || null
  };
};